import { Stack, Group } from "@mantine/core"
import { CommunicationStudioClasses } from "@tfg/types/constants/communication-studio.constant"

import { useGetTranslationsContext } from "../context/translationsContext/useGetTranslationsContext"
import { getActivityIcon } from "../ui/ActivityIcons"

export const ICON_SIZE = 48

export const ActivityIcon = ({ activityName }: { activityName: string }) => {
  const { t } = useGetTranslationsContext()
  return (
    <Stack h={ICON_SIZE * 2 + 14} gap={0}>
      {getActivityIcon({ activity: activityName, size: ICON_SIZE })}
      <Group
        wrap="nowrap"
        gap={0}
        className={CommunicationStudioClasses.ACTIVITY}
      >
        {t(`activities:${activityName}`)}
      </Group>
    </Stack>
  )
}
